import { render, staticRenderFns } from "./SoldAnomalyView.vue?vue&type=template&id=002b3bdd&scoped=true&"
import script from "./SoldAnomalyView.vue?vue&type=script&lang=ts&"
export * from "./SoldAnomalyView.vue?vue&type=script&lang=ts&"
import style0 from "./SoldAnomalyView.vue?vue&type=style&index=0&id=002b3bdd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002b3bdd",
  null
  
)

export default component.exports